import React, { useEffect, useState } from "react";
import {
  SlDrawer,
  SlButton
} from "@shoelace-style/shoelace/dist/react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import minusSvg from "../../assets/images/minus.svg";
function Merge(props) {
  const [choosedBrand, setChoosedBrand] = useState();
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const handleMerge = async () => {
    if (!choosedBrand || props.ids.length <= 0) {
      Toast("warning", "Please select Brands");
    } else {
      try {
        let res = await API({
          url: "/birdview/mergeBrands",
          method: "POST",
          responseType: "json",
          data: {
            merge_into: choosedBrand,
            ids_to_merge: props.ids.map((obj) => obj.id),
          },
        });
        if (res.code === 200) {
          Toast("success", "Merged Successfully!");
          props.loadData(0);
          props.setIds([]);
          props.setShow(false);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };
  const fetchBrands = async (inputValue='') => {
    try {
      let res = await API({
        url: "/birdview/allBrands",
        method: "POST",
        responseType: "json",
        data: {
          exclude_brandIds: props.ids.map((obj) => obj.id),
          search: inputValue,
        },
      });
      if (res.code === 200) {
        return res.data.result;
      }
      return [];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchBrands();
  }, [props.ids]);

  const handleRemove = (itemToRemove) => {
    props.setIds((prevIds) =>
      prevIds.filter((item) => item.id !== itemToRemove.id)
    );
  };

  return (
    <SlDrawer
      label="Merge Brands"
      open={props.show}
      onSlRequestClose={handleRequestClose}
      onSlAfterHide={() => {
        props.setShow(false);
      }}
      style={{ "--size": `${window.innerWidth <= 767 ? '100%' :'30vw'}` }}
    >
      <div className="border rounded px-3 py-2">
        <div className="d-flex gap-3">
          <div className="w-1/2">
            <h6 className="mb-3">Brands</h6>
            <div className="d-flex flex-col gap-2 shadow-inner px-2 py-2">
              {props?.ids?.map((item) => (
                <div className="d-flex align-center justify-between">
                  <span>{item.label}</span>
                  <img
                    src={minusSvg}
                    className="w-4 h-4 hover:cursor-pointer"
                    title="remove brand"
                    onClick={() => handleRemove(item)}
                    alt="minus-svg"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="w-1/2">
            <label className="mb-3">Merge Into</label>
            <AsyncSelect placeholder="Search Brand" cacheOptions defaultOptions loadOptions={fetchBrands} isClearable className="basic-multi-select" onChange={(e) => setChoosedBrand(e.value)} />
          </div>
        </div>
        <div className="d-flex gap-3 flex-1 mt-3">
          <SlButton variant="primary" size="small" onClick={handleMerge} disabled={!choosedBrand}>
            Merge
          </SlButton>
          <SlButton
            variant="danger"
            size="small"
            onClick={() => {
              props.setShow(false);
            }}
          >
            Cancel
          </SlButton>
        </div>
      </div>
    </SlDrawer>
  );
}

export default Merge;
